<template>
  <div>
    <div class="about">
      <div class="photo-content2">
        <img src="@/assets/img/case/01.png">
        <div class="mask"></div>
        <router-link to="/platform-services"></router-link>
        <p>平台服务</p>
      </div>
      <div class="photo-content2">
        <img src="@/assets/img/case/02.png">
        <div class="mask"></div>
        <router-link to="/training-service"></router-link>
        <p>人才网络</p>
      </div>
      <div class="photo-content2">
        <img src="@/assets/img/case/03.png">
        <div class="mask"></div>
        <router-link to="/meeting"></router-link>
        <p>智能会议</p>
      </div>
      <div class="photo-content2">
        <img src="@/assets/img/case/04.png">
        <div class="mask"></div>
        <p>更多案例，请联系我们...</p>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from '@/components/Footer'
export default {
  name: 'CaseSharing',
  components: {
    Footer
  }
}
</script>
<style lang="less" scoped>
@import '../../less/about.less';
</style>
